export class UserIdAndName
{
    refNo:string;
    userName:string
}